// src/context/FuzzScanTargetContext.jsx
import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { apiGet } from 'api/service';

const FuzzScanTargetContext = createContext(null);
const FALLBACK_CONTEXT = {
  targets: [],
  currentTargetId: '',
  setCurrentTargetId: () => {},
  loading: false,
  reloadTargets: async () => []
};

export const FuzzScanTargetProvider = ({ children }) => {
  const [targets, setTargets] = useState([]);          // UserTarget[]
  const [currentTargetId, setCurrentTargetId] = useState(''); // UserTarget.id
  const [loading, setLoading] = useState(true);

  const reloadTargets = useCallback(async () => {
    setLoading(true);
    try {
      // IMPORTANT: list user-target workspaces, not raw targets
      const data = await apiGet('/api/user-targets/');
      const items = Array.isArray(data)
        ? data
        : Array.isArray(data?.results)
        ? data.results
        : [];

      setTargets(items);
      setCurrentTargetId((prev) => {
        if (!items.length) return '';
        if (!prev) return String(items[0].id);
        const stillExists = items.some((item) => String(item.id) === String(prev));
        return stillExists ? String(prev) : String(items[0].id);
      });
      return items;
    } catch (e) {
      console.error('Failed to load user targets', e);
      setTargets([]);
      setCurrentTargetId('');
      return [];
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reloadTargets();
  }, [reloadTargets]);

  const value = {
    // targets are UserTarget rows: { id, name, target: { id, value, name, ... }, ... }
    targets,
    currentTargetId,       // UserTarget.id
    setCurrentTargetId,
    loading,
    reloadTargets
  };

  return (
    <FuzzScanTargetContext.Provider value={value}>
      {children}
    </FuzzScanTargetContext.Provider>
  );
};

export const useFuzzScanTarget = () => useContext(FuzzScanTargetContext) || FALLBACK_CONTEXT;
